import { render, staticRenderFns } from "./OrganPersonWorkInfoView.vue?vue&type=template&id=feb76b20&scoped=true"
import script from "./OrganPersonWorkInfoView.vue?vue&type=script&lang=js"
export * from "./OrganPersonWorkInfoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb76b20",
  null
  
)

export default component.exports